/**
 * Round number following the rule: round up when >= 0.5, round down when < 0.5
 * @param {number} value
 * @returns {number}
 */
function roundValue(value) {
  return Math.round(value);
}

/**
 * calculate VAT and totalPrice included or not included VAT, vatAmount.
 *
 * @param {number} priceValue - initial price.
 * @param {number} vat - vat value.
 * @param {boolean} vatIncluded - included or not included
 * @returns {{ basePrice: number, totalPrice: number }}
 */
function calculateVAT(priceValue: number, vat: number, vatIncluded: boolean) {
  let beforeVat = 0;
  let afterVat = 0;
  if (vatIncluded) {
    beforeVat = priceValue / (1 + vat / 100);
    afterVat = priceValue;
  } else {
    beforeVat = priceValue;
    afterVat = beforeVat * (1 + vat / 100);
  }
  return {
    beforeVat: roundValue(beforeVat),
    afterVat: roundValue(afterVat),
  };
}

export default calculateVAT;
